import { Admin, Resource, Layout, AppBar } from "react-admin";
import React from "react";
import { Route } from "react-router-dom";

import authClient, {
    getUserCompany,
    getUserCompanies
} from "./common/authClient";
import history from "./common/history";
import messages from "./messages";
import CustomAppBar from "./components/AppBar";
import MyMenu from "./components/MyMenu";
import MyLoginPage from "./components/MyLoginPage";
import SelectCompany from "./components/SelectCompany";
import MessageBoard from "./components/MessagesBoard";
import myRestClient from "../src/common/restClient";
import Companies from "./resources/Companies";
import RoleMappings from "./resources/RoleMappings";
import ConfigEdit from "./components/ConfigEdit";
import Customers from "./resources/Customers";
import CustomersMapping from "./resources/CustomersMapping";
import Events from "./resources/Events";
import EventTypes from "./resources/EventTypes";
import Roles from "./resources/Roles";
import Installations from "./resources/Installations";
import InstallationTypes from "./resources/InstallationTypes";
import Notifications from "./resources/Notifications";
import Users from "./resources/Users";
import Utilities from "./resources/Utilities";
import Tickets from "./resources/Tickets";
import myTheme from "./common/themes";
import {
    POLICY_COMPANIES,
    POLICY_CONSOLE,
    POLICY_CUSTOMERS,
    POLICY_CUSTOMERS_MAPPINGS,
    POLICY_INSTALLATIONS,
    POLICY_NOTIFICATIONS,
    POLICY_ROLE_MAPPINGS,
    POLICY_TICKETS,
    POLICY_USERS,
    POLICY_UTILITIES
} from "./common/rolesManagement";
import Configs from "./resources/Configs";
import ShowProfile from "./components/ShowProfile";
import Profile from "./resources/Profile";
import ResetPassword from "./components/ResetPassword";

const myCustomRoutes = [
    <Route exact path="/reset_password" component={ResetPassword} />,
    <Route path="/reset_password/:pwd_token" component={ResetPassword} />,
    <Route exact path="*" component={SelectCompany} />
];

const myCustomContextRoot = [
    <Route exact path="/notifications" component={MessageBoard} />,
    <Route exact path="/configs" component={ConfigEdit} id="1" />,
    <Route exact path="/profile" component={ShowProfile} id="1" />,
    <Route exact path="/reset_password" component={ResetPassword} />,
    <Route path="/reset_password/:pwd_token" component={ResetPassword} />
];

const CustomLayout = props => (
    <Layout {...props} appBar={CustomAppBar} menu={MyMenu} />
);
const FakeComponent = () => <span />;
const BaseLayout = props => (
    <Layout
        {...props}
        appBar={getUserCompanies().length > 1 ? BaseAppBar : FakeComponent}
        sidebar={FakeComponent}
        menu={FakeComponent}
    />
);
const BaseAppBar = props => <AppBar {...props} />;

export default () => {
    const my_company = getUserCompany();
    if (my_company) {
        return (
            <div>
                <Admin
                    theme={myTheme}
                    loginPage={MyLoginPage}
                    authProvider={authClient}
                    history={history}
                    locale="it"
                    i18nProvider={_ => messages.it}
                    dataProvider={myRestClient}
                    title="TeamSystem Cloud Console"
                    appLayout={CustomLayout}
                    customRoutes={myCustomContextRoot}
                >
                    {permissions => {
                        return [
                            // Only include the categories resource for admin users
                            (permissions.includes(POLICY_TICKETS.READ) ||
                                permissions.includes(
                                    POLICY_TICKETS.READ_ALL_COMPANIES
                                ) ||
                                permissions.includes(
                                    POLICY_TICKETS.READ_ALL_USERS
                                )) &&
                                Tickets(permissions),
                            permissions.includes(POLICY_CUSTOMERS.READ) &&
                                Customers(permissions),
                            permissions.includes(
                                POLICY_CUSTOMERS_MAPPINGS.READ
                            ) && CustomersMapping(permissions),
                            permissions.includes(POLICY_INSTALLATIONS.READ) &&
                                Installations(permissions),
                            (permissions.includes(POLICY_USERS.READ) ||
                                permissions.includes(POLICY_USERS.SELF_READ)) &&
                                Users(permissions),
                            permissions.includes(POLICY_COMPANIES.READ) &&
                                Companies(permissions),
                            permissions.includes(POLICY_ROLE_MAPPINGS.READ) &&
                                RoleMappings(permissions),
                            (permissions.includes(POLICY_UTILITIES.DOWNLOAD) ||
                                permissions.includes(POLICY_UTILITIES.UPLOAD) ||
                                permissions.includes(POLICY_UTILITIES.GUIDE)) &&
                                Utilities,
                            permissions.includes(
                                POLICY_NOTIFICATIONS.SEND_NOTIFICATIONS
                            ) && Notifications(permissions),
                            permissions.includes(
                                POLICY_CONSOLE.CAN_LOGIN_ON_MAINTENANCE
                            ) && Configs(permissions),
                            Roles,
                            Events,
                            Profile(permissions),
                            InstallationTypes,
                            EventTypes
                        ];
                    }}
                </Admin>
            </div>
        );
    } else {
        return (
            <Admin
                theme={myTheme}
                loginPage={MyLoginPage}
                appLayout={BaseLayout}
                customRoutes={myCustomRoutes}
                authProvider={authClient}
                history={history}
                locale="it"
                i18nProvider={_ => messages.it}
                dataProvider={myRestClient}
                title="TeamSystem Cloud Console"
            >
                <Resource name="dumb" />
            </Admin>
        );
    }
};



// WEBPACK FOOTER //
// ./src/App.js